import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import mixinActionBoxStyles from './mixinActionBoxStyles';
export default {
  name: 'CoreHeader',
  mixins: [mixinActionBoxStyles],
  props: {
    headerBG: {
      type: String,
      required: false,
      default: null
    },
    headline: {
      type: String,
      default: '',
      required: false
    },
    subtitle: {
      type: String,
      required: false,
      default: function _default() {
        return null;
      }
    },
    loader: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isSaving: {
      type: Boolean,
      required: false,
      default: false
    },
    formIsValid: {
      type: Boolean,
      required: false,
      default: false
    },
    cancelButton: {
      type: Boolean,
      required: false,
      default: false
    },
    saveButton: {
      type: Boolean,
      required: false,
      default: false
    },
    buttons: {
      type: Array,
      required: false,
      default: function _default() {
        return null;
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    isProductiveVersion: {
      type: Boolean,
      required: false,
      default: false
    },
    hasUnsyncedChanges: {
      type: Boolean,
      required: false,
      default: false
    },
    itemIsChanged: {
      type: Boolean,
      required: false,
      default: false
    },
    isTemplatesList: {
      type: Boolean,
      required: false,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      pageYOffset: 0,
      validStates: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    styles: function styles() {
      var width = 0;

      if (!this.saveButton && !this.cancelButton) {
        var _width = 10;
        return {
          width: 'fit-content',
          'max-width': "calc(100% - ".concat(_width, "px)")
        };
      }

      if (this.saveButton) {
        width = width + 165;
      }

      if (this.cancelButton) {
        width = width + 65;
      }

      return {
        'max-width': "calc(100% - ".concat(width, "px)"),
        width: 'fit-content'
      };
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    cloading: function cloading() {
      return this.$store.state.app.loading;
    },
    displayButtons: function displayButtons() {
      if (this.buttons) {
        return this.buttons;
      }

      var buttons = [];

      if (this.saveButton) {
        buttons.push({
          icon: 'fas fa-save',
          title: this.$i18n_t('Common.save'),
          disabled: this.templateContext && this.isProductiveVersion,
          type: 'submit',
          action: 'saveData'
        });
      }

      if (this.cancelButton) {
        buttons.push({
          icon: 'fal fa-times',
          color: 'danger',
          disabled: this.templateContext && this.isProductiveVersion,
          action: 'cancel',
          tooltip: this.$i18n_t('Common.cancel')
        });
      }

      return buttons.length ? buttons : null;
    }
  }),
  watch: {
    displayButtons: {
      handler: function handler(newV) {
        this.validStates = (newV || []).map(function (button) {
          return button.valid === undefined || button.valid;
        });
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.validStates = (this.displayButtons || []).map(function (button) {
      return button.valid === undefined || button.valid;
    });
    window.addEventListener('scroll', this.saveScrollOffset);
    this.actionBoxIsFixed = !this.headerBG && !this.headline && this.subtitle && !this.$slots['headline'];
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.saveScrollOffset);
  },
  methods: {
    buttonHasValidState: function buttonHasValidState(i) {
      if (i < this.validStates.length) {
        return this.validStates[i];
      }

      return true;
    },
    saveScrollOffset: function saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    },
    handleButtonClick: function handleButtonClick(buttonDefinition) {
      if (!buttonDefinition) {
        return;
      }

      if (buttonDefinition.action) {
        this.$emit(buttonDefinition.action);
      }

      if (buttonDefinition.onClick) {
        buttonDefinition.onClick();
      }
    }
  }
};